import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { CONFIG_TOKEN } from '@core/tokens';

import {
  AiAssistantPromptPreset,
  CreateConversationResponse,
  GetConversationMessagesResponse,
  GetConversationsResponse,
} from '@domain/ai-assistant/ai-assistant.models';

@Injectable({
  providedIn: 'root',
})
export class AiAssistantApiService {
  readonly #rootUrl = inject(CONFIG_TOKEN).backendRootUrl;
  readonly #httpClient = inject(HttpClient);

  public createConversation$(): Observable<CreateConversationResponse> {
    return this.#httpClient.post<CreateConversationResponse>(`${this.#rootUrl}/api/v1/ai/conversations`, null);
  }

  public getConversations$(limit?: number, offset?: number): Observable<GetConversationsResponse> {
    let params = new HttpParams();
    if (limit !== undefined) params = params.set('limit', limit);
    if (offset !== undefined) params = params.set('offset', offset);
    return this.#httpClient.get<GetConversationsResponse>(`${this.#rootUrl}/api/v1/ai/conversations`, { params });
  }

  public getConversationMessages$(conversationId: string): Observable<GetConversationMessagesResponse> {
    return this.#httpClient.get<GetConversationMessagesResponse>(
      `${this.#rootUrl}/api/v1/ai/conversations/${encodeURIComponent(conversationId)}/messages`
    );
  }

  public getPromptPresets$(): Observable<AiAssistantPromptPreset[]> {
    return this.#httpClient.get<AiAssistantPromptPreset[]>(`${this.#rootUrl}/api/v1/ai/prompt-presets`);
  }
}
